export default __webpack_public_path__ + "static/media/header-img1.8490aec8.png";